
(function () {
  function groupSections() {
    const nodes = Array.from(document.querySelectorAll('[data-pwi]'));
    if (!nodes.length) return;

    const eligible = (el) => {
      const enabled = el.getAttribute('data-pwi-group-enabled') === 'true';
      const id = (el.getAttribute('data-pwi-group') || '').trim();
      return enabled && id.length > 0;
    };

    for (let i = 0; i < nodes.length; i++) {
      const start = nodes[i];
      if (!eligible(start)) continue;

      const groupId = start.getAttribute('data-pwi-group').trim();
      const group = [start];
      let j = i + 1;

      while (j < nodes.length) {
        const el = nodes[j];
        if (!eligible(el)) break;

        const nextId = el.getAttribute('data-pwi-group').trim();
        if (nextId !== groupId) break;

        group.push(el);
        j++;
      }

      if (group.length < 2) {
        i = j - 1;
        continue;
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'pwi-group';
      wrapper.setAttribute('data-pwi-group-wrapper', groupId);
      wrapper.style.setProperty('--pwi-count', String(group.length));

      const first = group[0];
      first.parentNode.insertBefore(wrapper, first);

      group.forEach((sectionEl, idx) => {
        sectionEl.classList.add('pwi-group__item');
        sectionEl.style.setProperty('--pwi-index', String(idx));
        wrapper.appendChild(sectionEl);
      });

      i = j - 1;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', groupSections);
  } else {
    groupSections();
  }
})();
